
import { Policy, Acknowledgment } from "@/types";
import { Dispatch, SetStateAction } from "react";
import { usePolicyCore } from "./operations/policyCore";
import { usePolicyUpdate } from "./operations/policyUpdate";
import { usePolicyAccess } from "./operations/policyAccess";
import { usePolicyAcknowledgment } from "./operations/policyAcknowledgment";
import { usePolicyReview } from "./operations/policyReview";

export const usePolicyOperations = (
  user: any,
  policies: Policy[],
  setPolicies: Dispatch<SetStateAction<Policy[]>>,
  acknowledgments: Acknowledgment[],
  setAcknowledgments: Dispatch<SetStateAction<Acknowledgment[]>>,
  saveToStorage: (updatedPolicies: Policy[], updatedAcknowledgments?: Acknowledgment[]) => void
) => {
  // Import core operations
  const { addPolicy } = usePolicyCore(
    user, 
    policies, 
    setPolicies, 
    acknowledgments, 
    setAcknowledgments, 
    saveToStorage
  );

  // Import policy update operations
  const { updatePolicy, publishDraftPolicy, archivePolicy, unarchivePolicy } = usePolicyUpdate(
    policies, 
    setPolicies, 
    acknowledgments, 
    setAcknowledgments, 
    saveToStorage
  );

  // Import policy access operations
  const { 
    isUserPolicyOwner, 
    canUserViewDrafts, 
    getDraftPolicies, 
    getPublishedPolicies, 
    getArchivedPolicies 
  } = usePolicyAccess(
    policies,
    user
  );

  // Import policy acknowledgment operations
  const { acknowledgePolicy, isPolicyAcknowledged } = usePolicyAcknowledgment(
    user,
    policies,
    acknowledgments,
    setAcknowledgments,
    saveToStorage
  );

  // Import policy review operations
  const { reviewPolicy, getPolicyVersionHistory } = usePolicyReview(
    policies,
    setPolicies,
    acknowledgments,
    setAcknowledgments,
    saveToStorage
  );

  return {
    addPolicy,
    updatePolicy,
    isUserPolicyOwner,
    canUserViewDrafts,
    getDraftPolicies,
    getPublishedPolicies,
    getArchivedPolicies,
    acknowledgePolicy,
    isPolicyAcknowledged,
    reviewPolicy,
    getPolicyVersionHistory,
    publishDraftPolicy,
    archivePolicy,
    unarchivePolicy
  };
};
